// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"composer__composition\">\n	<div id=\"composition-wrapper\" class=\"composer__canvas-wrapper\">\n		<canvas id=\"composition\" class=\"composer__canvas\" width=\"900\" height=\"600\">"
    + container.escapeExpression((helpers.trans || (depth0 && depth0.trans) || helpers.helperMissing).call(depth0 != null ? depth0 : {},"Alternate content",{"name":"trans","hash":{},"data":data}))
    + "</canvas>\n	</div>\n</div>\n";
},"useData":true});
